function handleError(functionName, id) {
  console.error(`${functionName}: element with id "${id}" was not found.`);
}

function focus(elementId) {
  setTimeout(() => {
    const el = document.getElementById(elementId);
    if (el) el.focus();
    else handleError(focus.name, elementId);
  });
}

function select(elementId) {
  const el = document.getElementById(elementId);
  if (el) el.select();
  else handleError(select.name, elementId);
}

function getId() {
  return Math.random()
    .toString(36)
    .substring(7);
}

function downloadFile(url, fileName) {
  const id = getId();
  const link = document.createElement("a");
  link.id = id;
  link.href = url;
  if (fileName) link.download = fileName;
  link.style.display = "none";
  link.text = "download";
  //link.target = "_blank";
  document.body.appendChild(link);
  document.getElementById(id).click();
  document.body.appendChild(link).remove();
}

function getTextUrl(text, mime) {
  if (!mime) mime = "application/octet-stream";
  return `data:${mime};charset=utf-8,${encodeURIComponent(text)}`;
}

function scrollToEnd(id) {
  const el = document.getElementById(id);
  if (el && el.scrollHeight) el.scrollTop = el.scrollHeight - el.clientHeight;
}

function copyToClipboard(id) {
  const range = document.createRange();
  const el = document.getElementById(id);
  if (el) {
    range.selectNode(el);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
    document.execCommand("copy");
    window.getSelection().removeAllRanges();
  }
}

function jump(id) {
  setTimeout(() => {
    const el = document.getElementById(id);
    if (el) el.classList.add("pulse-fast-once");
  }, 0);
}

export {
  focus,
  select,
  getId,
  downloadFile,
  getTextUrl,
  scrollToEnd,
  copyToClipboard,
  jump,
};
